module.exports = __webpack_public_path__ + "images/img-10.47c78cad.jpg";